import React, { FC } from 'react'
import { classNames } from '@dt/fe-utils'
import SkeletonText from '../SkeletonText'
import './index.scss'

// interface
interface IProps {
  className?: string;
  style?: Record<string, any>;
  /** 是否有动画 */
  animated?: boolean;
}

/** Thumbnail类型样式的skeleton */
const ThumbnailSkeleton: FC<IProps> = ({ className, style, animated = true }) => {
  return (
    <div
      className={classNames('thumbnail-skeleton', className)}
      style={style}
    >
      <div className='left-thumbnail'>
        <SkeletonText animated={animated} style={{ width: '100%', height: '100%' }} />
      </div>
      <div className='right-label'>
        <div>
          <SkeletonText animated={animated} style={{ width: '70%' }} />
          <SkeletonText animated={animated} style={{ width: '90%' }} />
          <SkeletonText animated={animated} style={{ width: '60%' }} />
        </div>
      </div>
    </div>
  )
}

export default ThumbnailSkeleton
